import { updateAvailability } from "../services/user-service";
import { useAuthStore } from "../stores/authStore";
import React, { useState } from "react";
import { IconCar, IconClock, IconMapPin, IconPhone } from "@tabler/icons-react";

const HomePage = () => {
  const user = useAuthStore((state: any) => state.user);
  const [isAvailable, setIsAvailable] = useState<boolean>(user.isAvailable);
  const [isUpdating, setIsUpdating] = useState(false);
  console.log(user);

  const toggleAvailability = async (): Promise<void> => {
    setIsUpdating(true);
    try {
      const response = await updateAvailability(user.transportId, {
        isAvailable: !isAvailable,
      });
      setIsAvailable(response.isAvailable);
      // Actualizar el estado global del usuario
      useAuthStore.getState().login(useAuthStore.getState().token!, {
        ...user,
        isAvailable: response.isAvailable,
      });
    } catch (error) {
      console.error("Error updating availability:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-blue-50 pb-20">
      {/* Header con información del conductor */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-8">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <img
              src="https://cdn-icons-png.flaticon.com/512/4697/4697360.png"
              alt="Profile"
              className="w-16 h-16 rounded-full border-4 border-white shadow-lg"
            />
            <div
              className={`absolute -bottom-1 -right-1 w-6 h-6 rounded-full border-2 border-white ${
                isAvailable ? "bg-green-500" : "bg-gray-400"
              }`}
            ></div>
          </div>
          <div className="flex-1">
            <h1 className="text-xl font-bold text-gray-900">
              {user.firstName} {user.lastName}
            </h1>
            <p className="text-sm text-gray-600">
              {user.categoryName || "Conductor Binntu"}
            </p>
            <div className="flex items-center mt-1">
              <IconCar size={16} className="text-green-500 mr-1" />
              <span className="text-xs text-gray-500">
                Placa: {user.licensePlate}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Estado de disponibilidad */}
      <div className="px-6 py-8">
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <div className="text-center mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">
              Estado de Disponibilidad
            </h2>
            <p className="text-sm text-gray-600">
              {isAvailable
                ? "Estás disponible para recibir solicitudes"
                : "No estás disponible en este momento"}
            </p>
          </div>

          <div className="flex flex-col items-center space-y-4">
            {/* Toggle Switch */}
            <button
              onClick={toggleAvailability}
              disabled={isUpdating}
              className={`relative inline-flex h-14 w-28 items-center rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50 ${
                isAvailable
                  ? "bg-gradient-to-r from-green-500 to-green-600 shadow-lg"
                  : "bg-gray-300"
              }`}
            >
              <span
                className={`inline-block h-12 w-12 transform rounded-full bg-white shadow-md transition-all duration-300 ${
                  isAvailable ? "translate-x-[3.5rem]" : "translate-x-1"
                }`}
              />
            </button>

            {/* Estado actual */}
            <div className="flex items-center space-x-2">
              <div
                className={`w-3 h-3 rounded-full ${
                  isAvailable ? "bg-green-500" : "bg-gray-400"
                }`}
              ></div>
              <span
                className={`font-semibold ${
                  isAvailable ? "text-green-600" : "text-gray-600"
                }`}
              >
                {isAvailable ? "Disponible" : "No Disponible"}
              </span>
            </div>

            {isUpdating && (
              <div className="flex items-center space-x-2 text-sm text-gray-500">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-green-500"></div>
                <span>Actualizando...</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Información adicional */}
      {/*       <div className="px-6">
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Información del Conductor
          </h3>

          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                <IconCar size={20} className="text-green-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Vehículo</p>
                <p className="text-sm text-gray-600">
                  Placa: {user.licensePlate}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <IconClock size={20} className="text-blue-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Horario de trabajo
                </p>
                <p className="text-sm text-gray-600">
                  {user.startTime && user.endTime
                    ? `${user.startTime} - ${user.endTime}`
                    : "Horario flexible"}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                <IconPhone size={20} className="text-purple-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Contacto</p>
                <p className="text-sm text-gray-600">{user.phone}</p>
                {user.whatsapp && (
                  <p className="text-sm text-gray-600">
                    WhatsApp: {user.whatsapp}
                  </p>
                )}
              </div>
            </div>

            {user.paymentMethods && user.paymentMethods.length > 0 && (
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center">
                  <span className="text-yellow-600 font-bold">$</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900">
                    Métodos de pago
                  </p>
                  <p className="text-sm text-gray-600">
                    {user.paymentMethods.join(", ")}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div> */}

      {/* Espacio para el footer */}
      <div className="h-20"></div>
    </div>
  );
};

export default HomePage;
